import { TEmployeeRole, TRESPONSE_LOCATION_LIST } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';
import * as _ from 'lodash';
import { TTableCellType } from '../../table.type';

export const LOCATION_LIST_TABLE_MODEL = {
  createModel: (
    items: TRESPONSE_LOCATION_LIST['locationDetails'],
    employeeRole?: TEmployeeRole[number] | undefined,
  ) => {
    return ModifiersZTableModel.createTableModel(
      items,
      {
        padding: 8,
        select: {
          position: 'START',
          isMulti: true,
          size: 'DEFAULT',
        },
        headerConfig: _.compact([
          employeeRole === 'FACTORY_GROUP_ADMIN'
            ? {
                type: 'TEXT_CELL',
                text: 'FACTORY ID',
              }
            : undefined,
          {
            type: 'TEXT_CELL',
            text: 'table_model.LOCATIONTYPE',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.FLOOR',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.DEPARTMENT',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.SECTION',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.LINE',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.LOCATIONCODE',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.SUPERVISOR',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.MECHANIC',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.ELECTRICIAN',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.MAINTENANCE_INCHARGE',
          },
          {
            type: 'TEXT_CELL',
            text: '',
            widthInPx: 32,
          },
        ]),
      },
      (item) => {
        let tableValueMap = {
          floor: '--' as number | string,
          department: '--',
          section: '--',
          line: '--',
          supervisorInfo: item.assignedEmployeeDetails
            .filter((v) => v.employeeRole === 'LINE_SUPERVISOR')
            .map((v) => v.employeeName),
          mechanicInfo: item.assignedEmployeeDetails
            .filter((v) => v.employeeRole === 'MECHANIC')
            .map((v) => v.employeeName),
          electricianInfo: item.assignedEmployeeDetails
            .filter((v) => v.employeeRole === 'ELECTRICIAN')
            .map((v) => v.employeeName),
          maintenanceInchargeInfo: item.assignedEmployeeDetails
            .filter((v) => v.employeeRole === 'MAINTENANCE_INCHARGE')
            .map((v) => v.employeeName),
        };
        switch (item.location.locationType) {
          case 'PRODUCTION':
            tableValueMap = {
              ...tableValueMap,
              floor: item.location.floor,
              department: item.location.department,
              ...(item.location.section && {
                section: item.location.section,
              }),
              line: item.location.line,
            };
            break;
          case 'FLOATING':
          case 'FLOOR_NEEDLE_STORE':
            {
              tableValueMap = {
                ...tableValueMap,
                floor: item.location.floor,
              };
            }
            break;
          case 'SECTION_NEEDLE_STORE':
            {
              tableValueMap = {
                ...tableValueMap,
                floor: item.location.section,
              };
            }
            break;
          default:
            break;
        }
        return {
          type: 'ROW',
          rowItem: item,
          isSelected: false,
          cells: _.compact([
            employeeRole === 'FACTORY_GROUP_ADMIN'
              ? {
                  type: 'TEXT_CELL',
                  text: item.factoryId,
                }
              : undefined,
            {
              type: 'TEXT_CELL',
              text: item.location.locationType,
            },
            {
              type: 'TEXT_CELL',
              text: tableValueMap.floor,
            },
            {
              type: 'TEXT_CELL',
              text: tableValueMap.department,
            },
            {
              type: 'TEXT_CELL',
              text: tableValueMap.section,
            },
            {
              type: 'TEXT_CELL',
              text: tableValueMap.line,
            },
            {
              type: 'TEXT_CELL',
              text: item.locationDisplayCode,
            },
            {
              type: 'TEXT_LIST_CELL',
              text: tableValueMap.supervisorInfo || ['--'],
            },
            {
              type: 'TEXT_LIST_CELL',
              text: tableValueMap.mechanicInfo || ['--'],
            },
            {
              type: 'TEXT_LIST_CELL',
              text: tableValueMap.electricianInfo || ['--'],
            },
            {
              type: 'TEXT_LIST_CELL',
              text: tableValueMap.maintenanceInchargeInfo || ['--'],
            },
            {
              type: 'ACTION_CELL',
              actionType: 'VIEW',
              asIcon: true,
            },
          ] as TTableCellType[]),
        };
      },
    );
  },
};
